export const calculateTotalPrice = (items = []) => {
  return items.reduce((total, item) => {
    const quantity = Number(item.quantity) || 0
    const unitPrice = Number(item.unit_price) || 0
    return total + quantity * unitPrice
  }, 0)
}

// Subtotal of accessories items by sale price (quantity * sale_price).
export const calculateSaleSubtotal = (items = []) => {
  return items.reduce((total, item) => {
    const quantity = Number(item.quantity) || 0
    const salePrice = Number(item.sale_price) || 0
    return total + quantity * salePrice
  }, 0)
}

// Final accessories invoice total: package price or per-item sale subtotal,
// minus the flat discount, floored at 0.
export const calculateBillTotal = (usage = {}) => {
  const isPackage = usage?.bill_type === "package"
  const subtotal = isPackage
    ? Number(usage?.package_price) || 0
    : calculateSaleSubtotal(usage?.items)
  const discount = Number(usage?.discount) || 0
  return Math.max(subtotal - discount, 0)
}
